/**
 * WHAT AN ARMED DELETE LOOKS LIKE — a hairline warning outline over a half-opacity warning
 * ground, drawn around whatever the next click removes.
 *
 * ## Why this is a constant
 *
 * It was a string, copied by hand into twenty-seven places, and it drifted exactly as that
 * invites: the version pager had grown a 2px outline over a SOLID ground on the argument that
 * deleting a question costs more than deleting a branch. The argument was reasonable and the
 * result was a control that did not look like the app, in a heading where the heavier ring then
 * would not fit beside its neighbour. One string, one appearance.
 *
 * ## What is NOT in here, and why
 *
 * The BLEED — the negative margin and padding that give the ring room — is deliberately
 * separate, because it is the one part that legitimately differs. `ARMED_DELETE_BLEED` is what
 * eighteen of them use: a row sitting in a panel body with nothing beside it can spill 8px
 * either way for free, since the negative margin keeps it out of the layout. A row with a
 * neighbour cannot, and says so locally — see `version-selector`, which sits in a heading
 * between the scenario link and the panel's edge and uses half that.
 *
 * `rounded-lg` is out for the same reason: a few sites round differently or pair the outline
 * with a real border, and forcing those into one string would be a second kind of drift.
 */
export const ARMED_DELETE_PAINT = '[outline:1px_solid_var(--color-ws-warning-fg)] bg-ws-warning-bg/50';

/** The usual room to give it: layout-neutral, because the negative margin cancels the padding. */
export const ARMED_DELETE_BLEED = '-mx-2 px-2 -my-1 py-1';
